import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/deals/route-entries/root-route'
import { buildPageTitle } from '@/utils/seo'

export const Route = createFileRoute('/_layout/_private/app/deals/')({
  component: RootRoute,
  head: () => {
    return {
      meta: [
        {
          title: buildPageTitle('All Deals'),
        },
      ],
    }
  },
})
